<template>
  <main>
    <div class="menu" :style="{backgroundImage:'url('+list.menu.background+')'}">
      <div class="menu_title">
        <img :src="list.menu.title" alt="">
      </div>
      <div class="menu_list">
        <ul>
          <li v-for="items in list.menu.menulist" :key="items.id">
            <router-link tag="a" to="">
              <img :src="items.img" alt="">
              <p>{{items.intro}}</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="case">
      <div class="w">
        <div class="case_title">
          <img src="../../assets/images/bt拷贝.png" alt="">
        </div>
        <div class="case_list">
          <ul
            v-infinite-scroll="load"
            infinite-scroll-disabled="disabled"
          >
            <li v-for="item in list.case.caselist" :key="item.id">
              <router-link tag="a" to="" @click.native="caseid(item.id)">
                <div class="case_photo">
                  <!-- <div class="case_top" :style="{backgroundImage:'url('+item.img+')'}"
                       style="background-size: 100%;background-position:center center;"> -->
                  <div class="case_top">
                       <img class="case_img"  :src="item.img"/>
                    <div class="case_bottom">
                      <img src="../../assets/images/search.png" alt="">
                      <p>点击查看</p>
                    </div>
                  </div>
                </div>
                <h6 class="center p_top" v-html="item.name"></h6>
                <p class="center f14 " v-html="item.scene"></p>
              </router-link>
            </li>
          </ul>
          <p v-if="loading" class="center"><img src="../../assets/images/jzz.gif" alt="">全力加载中……</p>
          <p v-if="noMore" class="center">没有更多了</p>
        </div>

        <!-- <div class="case_list2" v-if='kind==4'>
          <ul
            v-infinite-scroll="load"
            infinite-scroll-disabled="disabled"
          >
            <li v-for="item in list.case.caselist" :key="item.id">
              <router-link tag="a" to="" @click.native="caseid(item.id)">
                <div class="case_photo">
                  <div class="case_top" :style="{backgroundImage:'url('+item.img+')'}"
                       style="background-size: 100%;background-position:50% 50%;">
                    <div class="case_bottom">
                      <img src="../../assets/images/search.png" alt="">
                      <p>点击查看</p>
                    </div>
                  </div>
                </div>
                <h6 class="center p_top">{{item.name}}</h6>
                <p class="center f14">{{item.scene}}</p>
              </router-link>
            </li>
          </ul>
          <p v-if="loading" class="center"><img src="../../assets/images/jzz.gif" alt="">全力加载中……</p>
          <p v-if="noMore" class="center">没有更多了</p>
        </div> -->

      </div>
    </div>
  </main>
</template>

<script>
  export default {
    data() {
      return {
        kind: '3',//当前选中的栏目
        list: {
          menu: {
            title: '',
            background: '',
            menulist: [
              {
                id: '',
                img: '',
                intro: ''
              },

            ]
          },
          case: {
            sum: 0,
            caselist: []
          }
        },
        loading: false,
        page:4
      };
    },
    methods: {
      load() {
        this.loading = true
        setTimeout(async () => {
          if (this.kind == 4) {
            var dt = await this.$axios.post('/api/itemmore', {
              menu: this.kind,
              amount: 4,
              type: 1,
              page: this.page + 1
            })
            dt.data = JSON.parse(dt.data)
            if (dt.status == 200) {
              if (dt.data.code !== 0) {
                this.$message({
                  type: 'info',
                  message: dt.data.msg
                });
                return;
              }
            } else {
              alert(dt.statusText)
              return;
            }
          } else {
            var dt = await this.$axios.post('/api/itemmore', {
              menu: this.kind,
              amount: 3,
              type: 1,
              page: this.page + 1
            })
            dt.data = JSON.parse(dt.data)
            if (dt.status == 200) {
              if (dt.data.code !== 0) {
                this.$message({
                  type: 'info',
                  message: dt.data.msg
                });
                return;
              }
            } else {
              alert(dt.statusText)
              return;
            }
          }
          for (var i = 0; i < dt.data.data.data.length; i++) {
            this.list.case.caselist.push(dt.data.data.data[i])
          }
          this.page = dt.data.data.page
          // console.log(this.list.case.sum)
          // console.log(dt)
          this.loading = false
        }, 1000)
      },
      async getlist(val) {
        var dt = await this.$axios.post('/api/items', {
          menu: val
        })
        dt.data = JSON.parse(dt.data)
        // console.log(dt)
        if (dt.status == 200) {
          if (dt.data.code != 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.list = dt.data.data
        // console.log(this.list.case.caselist.length, this.list.case.sum)
        // console.log(this.list.case.caselist.length >= this.list.case.sum)
      },
      caseid(val) {
        this.$router.push({
          name: 'details', params: {
            id: val+'.html',
            casemenu:this.$route.params.id.split('.')[0]
          }
        })
      }
    },
    created() {
      console.log(this.$route.params.id)
      this.getlist(this.$route.params.id.split('.')[0])
      this.kind = this.$route.params.id.split('.')[0]
    },
    beforeUpdate() {
      this.kind = this.$route.params.id.split('.')[0]
    },
    props: [
      'nav_id'
    ],
    computed: {
      noMore() {
        return this.list.case.caselist.length >= this.list.case.sum
      },
      disabled() {
        return this.loading || this.noMore
      },
    },
    watch: {
      nav_id(newval, oldval) {
        console.log(newval)
        this.kind = newval
        this.getlist(this.kind)
      }
    }
  };
</script>

<style lang="less" scoped>
  .menu {
    width: 100%;
    height: 600px;
    box-sizing: border-box;
    background-position:top left;
    background-size: 100% 100%;

    .menu_title {
      padding-top: 80px;
      text-align: center;

      img {
        height: 70px;
      }
    }

    .menu_list {
      padding-top: 80px;

      ul {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        li {

          img {
            width: 200px;
          }

          p {
            padding-top: 40px;
            text-align: center;
            color: #fff;
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .case {
    width: 100%;
    min-height: 500px;

    .case_title {
      width: 100%;
      text-align: center;
      padding-top: 80px;

      img {
        height: 60px;
      }
    }

    .case_list {
      ul {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 80px;

        li {
          width: 30%;
          padding-bottom: 15px;

          .case_photo {
            width: 100%;
            padding: 10px;
            background: #ddd;
            box-sizing: border-box;

            .case_top {
              height: 230px;
              position: relative;
              overflow: hidden;

              .case_img{
                     transition: all 0.5s;
                     width: 100%;
                     height: auto;
                     min-height:100%
              }

              .case_bottom {
                position: absolute;
                top:0;
                left: 0;
                width: 100%;
                height: 100%;
                text-align: center;
                background: #111;
                opacity: 0;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                box-sizing: border-box;

                img {
                  width: 20%;
                }
              }
            }

            .case_top:hover .case_bottom {
              opacity: 0.7;
            }

            .case_top:hover {
              .case_img{
                transform: scale(1.1);
              }
            }
          }

          h6 {
            font-size: 18px;
            font-weight: bold;
            padding: 15px 8px 8px;
          }

          p {
            font-size: 14px;
            color: #999;
          }
        }

        li:nth-child(3n+2) {
          margin: 0 5%;
        }
      }

      > p {
        padding: 20px;
        color: #999999;

        img {
          width: 30px;
        }
      }
    }

    .case_list2 {
      ul {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 80px;

        li {
          width: 22%;
          padding-bottom: 15px;
          margin-right: 4%;

          .case_photo {
            width: 100%;
            padding: 10px;
            background: #ddd;
            box-sizing: border-box;

            .case_top {
              height: 405px;

              .case_bottom {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                text-align: center;
                background: #111;
                opacity: 0;
                color: #fff;
                box-sizing: border-box;

                img {
                  width: 20%;
                }

                span {
                  width: auto;
                  height: auto;
                  display: inline-block;
                }
              }
            }

            .case_top:hover .case_bottom {
              opacity: 0.7;
            }

            .case_top:hover {
              background-size: 110% !important;
              transition: all 0.5s;
            }
          }

          h6 {
            font-size: 18px;
            font-weight: bold;
            padding: 15px 8px 8px;
          }

          p {
            font-size: 14px;
            color: #999;
          }
        }

        li:nth-child(4n) {
          margin-right: 0%;
        }
      }

      > p {
        padding: 20px;
        color: #999999;

        img {
          width: 30px;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/pc/items.vue